import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServiceApiModel } from './abstract-service-api.model';
import { environment } from '../../../environments/environment';

@Injectable()
export class CrmServiceModel extends ServiceApiModel {
    constructor(http: HttpClient) {
        super(http);
    }

    public getUsersEndpoint(): string {
        return `${environment.CRM_SERVICE_URL}/users`;
    }

    public getOrganizationsEndpoint(): string {
        return `${environment.CRM_SERVICE_URL}/organizations`;
    }

    public getInvitationsEndpoint(): string {
        return `${environment.CRM_SERVICE_URL}/invitations`;
    }

    public getOrganizationInvitedUsersEndpoint(organizationId: string): string {
        return `${environment.CRM_SERVICE_URL}/organizations/${organizationId}/invitations`;
    }

    public getManagedRetailersEndpoint(organizationId: string): string {
        return `${environment.CRM_SERVICE_URL}/organizations/${organizationId}/retailers`;
    }

    public getOrganizationInvitationsEndpoint(organizationId: string): string {
        return `${environment.CRM_SERVICE_URL}/organizations/${organizationId}/invitations`;
    }

    public getOrganizationRetailerEndpoint(organizationId: string, retailerId: string): string {
        return `${environment.CRM_SERVICE_URL}/organizations/${organizationId}/retailers/${retailerId}`;
    }

    public resendEmailVerification(): Observable<null> {
        return this.makeHttpObservableRequest<null>({
            method: 'POST',
            url: `${this.getUsersEndpoint()}/me/email-verification`
        });
    }
}
